var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"mb-10 logo-container"},[(_vm.setup)?_c('v-img',{attrs:{"src":_vm.setup.picture,"max-width":"260px"}}):_vm._e()],1),_c('sign-up-form',{attrs:{"init":true}})],1),_c('primeit-message-snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }